<template>
  <div class="action-section">
    <!-- Valid Status - View on IRBM & Send Email -->
    <div 
      v-if="alreadySubmitted && !isExpired && status === 'Valid'" 
      class="action-buttons">
      <a 
        :href="validationLink" 
        target="_blank" 
        class="modern-btn primary-btn">
        <svg 
          width="16" 
          height="16" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2" 
          viewBox="0 0 24 24">
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
          <polyline points="15,3 21,3 21,9"/>
          <line 
            x1="10" 
            y1="14" 
            x2="21" 
            y2="3"/>
        </svg>
        VIEW ON IRBM
      </a>
      <button 
        class="modern-btn info-btn" 
        @click="$emit('send-email')">
        <svg 
          width="16" 
          height="16" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2" 
          viewBox="0 0 24 24">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
        SEND EMAIL
      </button>
    </div>
  
    <!-- Invalid Status - Resubmit -->
    <div 
      v-else-if="alreadySubmitted && !isExpired && status === 'Invalid'" 
      class="action-buttons">
      <button 
        class="modern-btn primary-btn" 
        @click="$emit('next')">
        <svg 
          width="16" 
          height="16" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2" 
          viewBox="0 0 24 24">
          <polyline points="1,4 1,10 7,10"/>
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
        </svg>
        RESUBMIT
      </button>
    </div>
  
    <!-- Submitted Status - Refresh/Reload -->
    <div 
      v-else-if="alreadySubmitted && !isExpired && status === 'Submitted'" 
      class="action-buttons">
      <button 
        class="modern-btn info-btn" 
        @click="refreshStatus">
        <svg 
          width="16" 
          height="16" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2" 
          viewBox="0 0 24 24">
          <polyline points="1,4 1,10 7,10"/>
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
        </svg>
        REFRESH STATUS
      </button>
    </div>
  
    <!-- Expired - Back to Homepage -->
    <div 
      v-else-if="isExpired" 
      class="action-buttons">
      <button 
        class="modern-btn secondary-btn" 
        @click="$emit('cancel')">
        <svg 
          width="16" 
          height="16" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2" 
          viewBox="0 0 24 24">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        </svg>
        Back to Homepage
      </button>
    </div>
  
    <!-- Not Submitted - Cancel/View Receipt/Next -->
    <div 
      v-else-if="!alreadySubmitted && !isExpired" 
      class="action-buttons">
      <button 
        class="modern-btn secondary-btn" 
        @click="$emit('cancel')">
        <svg 
          width="16" 
          height="16" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2" 
          viewBox="0 0 24 24">
          <line 
            x1="18" 
            y1="6" 
            x2="6" 
            y2="18"/>
          <line 
            x1="6" 
            y1="6" 
            x2="18" 
            y2="18"/>
        </svg>
        Cancel
      </button>
      <button 
        class="modern-btn info-btn" 
        @click="$emit('show-receipt')">
        <svg 
          width="16" 
          height="16" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2" 
          viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14,2 14,8 20,8"/>
        </svg>
        View Receipt
      </button>
      <button 
        class="modern-btn primary-btn" 
        @click="$emit('next')">
        Next
        <svg 
          width="16" 
          height="16" 
          fill="none" 
          stroke="currentColor" 
          stroke-width="2" 
          viewBox="0 0 24 24">
          <polyline points="9,18 15,12 9,6"/>
        </svg>
      </button>
    </div>
  </div>
</template>
  
  <script>
export default {
    name: 'ActionButtonsSection',
    props: {
        alreadySubmitted: {
            type: Boolean,
            required: true,
        },
        isExpired: {
            type: Boolean,
            required: true,
        },
        status: {
            type: String,
            default: 'Submitted',
        },
        validationLink: {
            type: String,
            default: '',
        },
        consolidatedId: {
            type: Number,
            default: null,
        },
    },
    emits: ['next', 'cancel', 'show-receipt', 'refresh-status', 'send-email'],
    methods: {
        refreshStatus() {
            this.$emit('refresh-status');
        },
    },
};
</script>
  
  <style scoped>
.action-section {
    background: white;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 24px;
}

.action-buttons {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.modern-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 120px;
    justify-content: center;
    text-transform: uppercase;
    letter-spacing: 0.025em;
}

.primary-btn {
    background: #ef5350;
    color: white;
}

.primary-btn:hover {
    background: #e53935;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(239, 83, 80, 0.3);
}

.secondary-btn {
    background: white;
    color: #374151;
    border: 2px solid #e5e7eb;
}

.secondary-btn:hover {
    background: #f9fafb;
    border-color: #d1d5db;
    transform: translateY(-1px);
}

.info-btn {
    background: #ef5350;
    color: white;
}

.info-btn:hover {
    background: #e53935;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

@media (max-width: 768px) {
    .action-section {
        padding: 20px;
    }
    .action-buttons {
        flex-direction: column;
    }
    .modern-btn {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/e-invoice/portal/components/ActionButtonsSection.vue